import { useQuery } from "@tanstack/react-query";
import type { DateTime } from "luxon";
import { backendService } from "../../../services/backend.service";
import type { ManagementCenterMultiDepartmentResponse } from "../../../utils/models";

interface DateRangeParams {
	startDate: DateTime;
	endDate: DateTime;
}

export const useManagementCenterMultiPpd = ({ startDate, endDate }: DateRangeParams) => {
	return useQuery<ManagementCenterMultiDepartmentResponse>({
		queryKey: ["mc-multi-ppd", startDate.toISODate(), endDate?.toISODate()],
		queryFn: async () => {
			const response = await backendService.getManagementCenterMultiPpdComparison({ startDate, endDate });
			return response.data;
		},
	});
};

export const useManagementCenterMultiHppd = ({ startDate, endDate }: DateRangeParams) => {
	return useQuery<ManagementCenterMultiDepartmentResponse>({
		queryKey: ["mc-multi-hppd", startDate.toISODate(), endDate?.toISODate()],
		queryFn: async () => {
			const response = await backendService.getManagementCenterMultiHppdComparison({ startDate, endDate });
			return response.data;
		},
	});
};

export const useManagementCenterMultiStaffSatisfaction = ({ startDate, endDate }: DateRangeParams) => {
	return useQuery<ManagementCenterMultiDepartmentResponse>({
		queryKey: ["mc-multi-staff-satisfaction", startDate.toISODate(), endDate?.toISODate()],
		queryFn: async () => {
			const response = await backendService.getManagementCenterMultiStaffSatisfaction({ startDate, endDate });
			return response.data;
		},
	});
};

export const useManagementCenterMultiShiftFillRate = ({ startDate, endDate }: DateRangeParams) => {
	return useQuery<ManagementCenterMultiDepartmentResponse>({
		queryKey: ["mc-multi-shift-fill-rate", startDate.toISODate(), endDate?.toISODate()],
		queryFn: async () => {
			const response = await backendService.getManagementCenterMultiShiftFillRate({ startDate, endDate });
			return response.data;
		},
	});
};

export const useManagementCenterMultiOtUse = ({ startDate, endDate }: DateRangeParams) => {
	return useQuery<ManagementCenterMultiDepartmentResponse>({
		queryKey: ["mc-multi-ot-use", startDate.toISODate(), endDate?.toISODate()],
		queryFn: async () => {
			const response = await backendService.getManagementCenterMultiOtUse({ startDate, endDate });
			return response.data;
		},
	});
};

export const useManagementCenterMultiAgencyUse = ({ startDate, endDate }: DateRangeParams) => {
	return useQuery<ManagementCenterMultiDepartmentResponse>({
		queryKey: ["mc-multi-agency-use", startDate.toISODate(), endDate?.toISODate()],
		queryFn: async () => {
			const response = await backendService.getManagementCenterMultiAgencyUse({ startDate, endDate });
			return response.data;
		},
	});
};

export const useManagementCenterMultiWeekActiveUsers = ({ startDate, endDate }: DateRangeParams) => {
	return useQuery<ManagementCenterMultiDepartmentResponse>({
		queryKey: ["mc-multi-week-active-users", startDate.toISODate(), endDate?.toISODate()],
		queryFn: async () => {
			const response = await backendService.getManagementCenterMultiWeekActiveUsers({ startDate, endDate });
			return response.data;
		},
	});
};
